import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { UtilService } from '@helpers/util.service';

import * as models from '../../models';

@Component({
  selector: 'app-real-property-basic-info',
  templateUrl: './real-property-basic-info.component.html',
  styleUrls: ['./real-property-basic-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RealPropertyBasicInfoComponent {
  @Input()
  public readonly application: models.RealPropertyListByAgentList[0];

  constructor(private util: UtilService) {}

  getPath(url: string) {
    return this.util.getFilePath() + url;
  }
}
